var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialmedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M474 570q26-32 38.5-66t12.5-79q0-45-12.5-79T474 280q76-17 133.5 23T665 425q0 82-57.5 122T474 570Zm216 326v-94q0-51-26-95t-90-74q173 22 236.5 64T874 802v94H690Zm110-289V507H700v-60h100V347h60v100h100v60H860v100h-60Zm-485-32q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42ZM0 896v-94q0-35 18.5-63.5T68 696q72-32 128.5-46T315 636q62 0 118 14t128 46q31 14 50 42.5t19 63.5v94H0Zm315-381q39 0 64.5-25.5T405 425q0-39-25.5-64.5T315 335q-39 0-64.5 25.5T225 425q0 39 25.5 64.5T315 515ZM60 836h510v-34q0-16-8-30t-25-22q-69-32-117-43t-105-11q-57 0-104.5 11T92 750q-15 7-23.5 21.5T60 802v34Zm255-411Zm0 411Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmedia);
export default __webpack_public_path__ + "static/media/socialmedia.a57656740535fb09120a1adb730ef8a9.svg";
export { ForwardRef as ReactComponent };